import consts from '../../../consts'


function onClickMenu(id_menu) {
    setTimeout(() => {
        document.getElementById(`treeview-${id_menu}`).style = 'display: ' + document.getElementById(`treeview-${id_menu}`).style.display
    }, 350);
}

export function MenuTree(props){
    return (
        <li className="nav-item has-treeview" title={props.menu.nome}>
            <a href={consts.linkApp} className="nav-link" onClick={() => {
                onClickMenu(props.menu.id_menu)
            }}>
                <i className={`nav-icon fas fa-${props.menu.icone}`}></i>
                <p>
                    {props.menu.nome}
                    <i className="right fas fa-angle-left"></i>
                </p>
            </a>
            <ul id={`treeview-${props.menu.id_menu}`} className="nav nav-treeview">
                {props.children}
            </ul>
        </li >
    )
}